module.exports = __webpack_public_path__ + "static/media/checklist-filled.f2c3935b.svg";